import { createContext } from "react";

const isUserLoggedContext =createContext();

export default isUserLoggedContext;